import { SELECTED_PROMPT_AI_INSTANCE  } from "../../common/actionTypes";
const INITIAL_STATE = { 
    selectedPromptAiInstance: ""
  };
  
  
  const PromptAiReducer = (state = INITIAL_STATE, action) => {
    if (action.type === undefined) {
      return state;
    }

    switch (action.type) {
      case SELECTED_PROMPT_AI_INSTANCE: {
        console.log("action.payload",action.payload);
        return { ...state,
          selectedPromptAiInstance:action.payload};
      }
      default:
        return state;
    }
  };
  
  export default PromptAiReducer;